module.exports = __webpack_public_path__ + "img/comments-3.4d82f7d3.jpg";